import React, { useState, useRef, useEffect } from 'react';

import _isEmpty from 'lodash.isempty';

import Popover from 'react-popover';
import { EditorState } from 'draft-js';
import cx from 'classnames';
import { Icon, Text } from '../../../../../../../ui-kit';

import CommentTextEditorV2, {
  getContentState } from
'../../../../../common/CommentTextEditorV2';
import { getCurrentUserId } from '../../../../../../../common/utils';

import '../styles/_add-comment-v2.scss';



















const AddComment = (props) => {
  const {
    metadata,
    filterByMetadataFlag,
    onVisibilityChange,
    hideVisibility
  } = props;
  const { visibility: dropdownVisibility, timestamp } = metadata || {};
  const [editorState, setEditorState] = useState(
    EditorState.createEmpty()
  );
  const [assetIds, setAssetIds] = useState([]);
  const [visibility, setVisibility] = useState(dropdownVisibility);
  const { closePopover, children } = props;

  const popoverRef = useRef(null);
  const [popoverParent, setPopoverParent] = useState(document.body);

  useEffect(() => {
    setPopoverParent(popoverRef.current || document.body);
  }, [popoverRef]);

  const handleUpdateContent = (updatedEditorState) => {
    setEditorState(updatedEditorState);
  };

  const handleFilesChange = (updatedAssetIds) => setAssetIds(updatedAssetIds);

  const getMetadata = () => {
    const additionalFields = {};

    if (visibility && visibility === 'SHOOTSTA_INTERNAL') additionalFields.internalMode = true;

    if (filterByMetadataFlag === void 0) {
      return JSON.stringify({ ...metadata, ...additionalFields, visibility });
    }

    return JSON.stringify({
      ...metadata,
      ...filterByMetadataFlag,
      ...additionalFields,
      visibility
    });
  };

  const handleSave = async () => {
    const { createComment, onAddComment, shotId, sceneId } = props;

    const { json, plainText } = getContentState(editorState);

    if (!plainText.trim()) {
      return;
    }

    const { data, error } = await createComment({
      input: {
        content: json,
        metadata: getMetadata(),
        assetIds,
        shotId,
        sceneId
      }
    });

    if (!data || error) {
      return;
    }

    if (onAddComment) {
      onAddComment(data);
    }

    closePopover();
  };

  const onChangeVisibility = (value) => {
    if (onVisibilityChange) onVisibilityChange(value);
    setVisibility(value);
  };

  const renderHeader = () => {
    const { getTitle } = props;

    return (
      <div className="comment-popover__header">
        <Text heading3 noMargin="top">
          Add Comment
        </Text>
        {getTitle ? <Text heading5>{getTitle()}</Text> : null}
        <Icon
          clickable
          className="comment-popover__close-icon"
          name="close"
          onClick={closePopover}
          color="regent"
          hoverColor="black"
          size={15} />

      </div>);

  };

  const renderBody = () => {
    const { resourceOrganisationId, onInputFocus, hideTimestamp } = props;

    const hasCurrentUserId = !_isEmpty(getCurrentUserId());

    return (
      <div className="comment-popover__body">
        <CommentTextEditorV2
          placeholder="Leave a comment..."
          editorState={editorState}
          onUpdateContent={handleUpdateContent}
          onSave={handleSave}
          assetIds={assetIds}
          onFilesChange={handleFilesChange}
          organisationId={resourceOrganisationId}
          canAddAsset
          canDeleteAsset
          onFocus={onInputFocus}
          setFocusOnMount={hasCurrentUserId}
          timestamp={timestamp}
          hideTimestamp={hideTimestamp}
          {...
          !hideVisibility ?
          {
            visibility,
            onChangeVisibility
          } :
          {}} />


      </div>);

  };

  const renderContent = () =>
  <div className="comment-popover__container">
      {renderHeader()}
      {renderBody()}
    </div>;


  return (
    <div className="comment-popover__parent" ref={popoverRef}>
      <Popover
        {...props}
        key={popoverRef.current ? 'ready' : 'not-ready'}
        isOpen
        preferPlace="right"
        enterExitTransitionDurationMs={0}
        body={renderContent()}
        tipSize={0.01}
        onOuterAction={closePopover}
        className={cx('comment-popover', 'add-comment')}
        appendTarget={popoverParent}>

        {children}
      </Popover>
    </div>);

};

export default AddComment;